import { Box } from '@mui/material'
import PredictionLabel from './PredictionLabel'
import PredictionInterval from './PredictionInterval'
import Prediction from './Prediction'
import { PadithiEnum, PredictionType } from '../../../utils/enums'

const PredictionCard = ({ predictions, category, conditionType, predictionType, userCurrentTimezone }) => {

    const isShowInterval = conditionType !== PadithiEnum.LAL_KITAB || predictionType === PredictionType.DAY;
    const isShowPredictionCategory = conditionType !== PadithiEnum.LAL_KITAB || predictionType !== PredictionType.DAY;

    return (
        <Box sx={{ mb: 3 }}>
            {isShowPredictionCategory &&
                <PredictionLabel category={category} />
            }
            <Box sx={{ pl: 2 }}>
                {predictions.map((p, i) => (
                    <Box key={i} sx={{ mb: 1.5 }}>

                        {isShowInterval && (
                            <PredictionInterval
                                intervals={p?.intervals}
                                timezone={userCurrentTimezone}
                                conditionType={conditionType}
                                predictionType={predictionType}
                            />
                        )}

                        <Prediction
                            key={i}
                            prediction={p}
                        />
                    </Box>
                ))}
            </Box>
        </Box>
    )
}

export default PredictionCard
